import { cleanObject } from '../utils/helpers/common.helpers'

export const adaptParams = (params) => {
  const cleanParams = cleanObject(params)
  return cleanParams
}
